import { render, staticRenderFns } from "./AvidiaFooterInvestment.vue?vue&type=template&id=3b7aa312&scoped=true"
import script from "./AvidiaFooterInvestment.vue?vue&type=script&lang=ts"
export * from "./AvidiaFooterInvestment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7aa312",
  null
  
)

export default component.exports